var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortingIconAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50491 5.49509L8 2L8.66667 2.66667L8.94281 2.94281L11.4951 5.49509L10.5523 6.4379L8 3.88562L5.44771 6.4379L4.50491 5.49509Z",
    fill: "#FF832B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4951 10.5049L8 14L7.33333 13.3333L7.05719 13.0572L4.50491 10.5049L5.44771 9.5621L8 12.1144L10.5523 9.5621L11.4951 10.5049Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIconAsc);
export default __webpack_public_path__ + "static/media/sorting-icon-asc.be1ac2e1817aafaf135f8d25cdee1880.svg";
export { ForwardRef as ReactComponent };